import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { AxiosError } from "axios";
import { classToPlain, plainToClass } from "class-transformer";
import { ChangeRequest, FormA, FormB, FormBLineItem, FormBLineItems, FurtherInfos } from "../models/ChangeRequest";
import { API_PATH } from "../models/Constants";
import { FileModel } from "../models/FileModel";
// import { sample } from "lodash"

export default class ChangeRequestApi {
    private http: HTTPClient;
    private static instance: ChangeRequestApi | null = null;

    private constructor(http: HTTPClient) {
        this.http = http;
    }

    public static getInstance(http: HTTPClient): ChangeRequestApi {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new ChangeRequestApi(http);
        return this.instance;
    }

    async getChangeRequest(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[ChangeRequest | null, AxiosError | null]> {
        return new Promise(resolve => {
            // const fakeData = plainToClass(ChangeRequest,
            //     {
            //         "subject_id": 4207,
            //         "application_id": -220075,
            //         "contract_id": 20046,
            //         "project_app_id": 220075,
            //         "contract_code": "20046/204789/2018",
            //         "cr_reference": "CRXX01",
            //         "identification_code": "20046/204789/2018",
            //         "description": null,
            //         "project_title": "CAPITAL INVESTMENT IN MODERN AGRICULTURE MACHINERY",
            //         "app_status": "FURTHER INFO",
            //         "status": "FURTHER INFO",
            //         "status_code": "000170",
            //         "cod_modu": "M04.1",
            //         "type_modu": null,
            //         "measure": "CHANGE REQUEST APPLICATION",
            //         "proj_dt_start": "2018-12-04T00:00:00+01:00",
            //         "proj_dt_end": "2022-12-31T00:00:00+01:00",
            //         "total_pub_elig_amount": 6559.0,
            //         "pub_elig": 6559.0,
            //         "priv_share": null,
            //         "total_proj_cost": null,
            //         "can_edit": 0,
            //         "can_submit": 1,
            //         "can_pending": 0,
            //         "remarks": "Extend Dates Test",
            //         "farmer_informed": null,
            //         "paths": {
            //             "form-a": 1,
            //             "form-b": 0,
            //             "form-b-line-items": null,
            //             "form-further-info": 0
            //         }
            //     }
            // );
            // resolve([fakeData, null]);

            this.http
                .get<ChangeRequest>(
                    `${API_PATH}/changereq/overview/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resolve([plainToClass(ChangeRequest, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async saveChangeRequest(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: { remarks: string }
    ): Promise<[ChangeRequest | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<ChangeRequest>(
                    `${API_PATH}/changereq/overview/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    data
                )
                .then(resp => {
                    resolve([plainToClass(ChangeRequest, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async withdrawnChangeRequest(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[boolean | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<boolean>(
                    `${API_PATH}/changereq/withdraw/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async createChangeRequest(
        subjectId: string,
        contractId: string
    ): Promise<[{ application_id: number } | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<{ application_id: number }>(
                    `${API_PATH}/changereq/create/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}`
                )
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async submitChangeRequest(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data?: FileModel
    ): Promise<[boolean | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<boolean>(
                    `${API_PATH}/changereq/submit/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    data
                )
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getChangeRequestFormA(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[FormA | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<FormA>(
                    `${API_PATH}/changereq/form-a/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resolve([plainToClass(FormA, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getChangeRequestFormB(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[FormB | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<FormB>(
                    `${API_PATH}/changereq/form-b/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resolve([plainToClass(FormB, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setChangeRequestFormB(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: FormB
    ): Promise<[FormB | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<FormB>(
                    `${API_PATH}/changereq/form-b/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    classToPlain(data)
                )
                .then(resp => {
                    resolve([plainToClass(FormB, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getChangeRequestFormBLineItems(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[FormBLineItems | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .get<FormBLineItems>(
                    `${API_PATH}/changereq/form-b-line-items/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resp.data.lineItems = resp.data.lineItems.map(e => {
                        const hash = FormBLineItem.toHash(e);
                        return {
                            ...e,
                            hash
                        } as FormBLineItem;
                    });
                    resolve([plainToClass(FormBLineItems, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async getChangeRequestFormFurtherInfo(
        subjectId: string,
        contractId: string,
        applicationId: string
    ): Promise<[FurtherInfos | null, AxiosError | null]> {
        return new Promise(resolve => {
            // const fakeData = plainToClass(FurtherInfos,
            //     {
            //         "furtherInfos": [
            //             {
            //                 "application_id": 220075,
            //                 "subject_id": 4207,
            //                 "question": "After submit from customer portal",
            //                 "answer": null,
            //                 "remarks": null,
            //                 "can_answer": 0
            //             },
            //             {
            //                 "application_id": 220075,
            //                 "subject_id": 4207,
            //                 "question": "New question",
            //                 "answer": null,
            //                 "remarks": null,
            //                 "can_answer": 0
            //             },
            //             {
            //                 "application_id": 220075,
            //                 "subject_id": 4207,
            //                 "question": "Do you like Cats ?",
            //                 "answer": "No.",
            //                 "remarks": null,
            //                 "can_answer": 0
            //             },
            //             {
            //                 "application_id": 220075,
            //                 "subject_id": 4207,
            //                 "question": "Do you like dogs ?",
            //                 "answer": "Yes",
            //                 "remarks": null,
            //                 "can_answer": 0
            //             }
            //         ]
            //     }
            // )
            // resolve([fakeData, null]);

            this.http
                .get<FurtherInfos>(
                    `${API_PATH}/changereq/form-further-info/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`
                )
                .then(resp => {
                    resolve([plainToClass(FurtherInfos, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @param data
     * @returns
     */
    async setChangeRequestFormFurtherInfo(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: FurtherInfos
    ): Promise<[FurtherInfos | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<FurtherInfos>(
                    `${API_PATH}/changereq/form-further-info/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    classToPlain(data)
                )
                .then(resp => {
                    resolve([plainToClass(FurtherInfos, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @param {FormA} data
     * @returns
     */
    async setChangeRequestFormA(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: FormA
    ): Promise<[FormA | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<FormA>(
                    `${API_PATH}/changereq/form-a/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    classToPlain(data)
                )
                .then(resp => {
                    resolve([plainToClass(FormA, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @param {FormBLineItems} data
     * @returns
     */
    async setChangeRequestFormBLineItems(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: FormBLineItems
    ): Promise<[FormBLineItems | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<FormBLineItems>(
                    `${API_PATH}/changereq/form-b-line-items/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    classToPlain(data)
                )
                .then(resp => {
                    resp.data.lineItems = resp.data.lineItems.map(e => {
                        const hash = FormBLineItem.toHash(e);
                        return {
                            ...e,
                            hash
                        } as FormBLineItem;
                    });
                    resolve([plainToClass(FormBLineItems, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param {String} subjectId
     * @param {String} contractId
     * @returns
     */
    async setReqPSApproval(
        subjectId: string,
        contractId: string,
        applicationId: string,
        data: { notes: string }
    ): Promise<["ok" | null, AxiosError | null]> {
        return new Promise(resolve => {
            this.http
                .post<"ok">(
                    `${API_PATH}/changereq/ps-approval/${encodeURIComponent(subjectId)}/${encodeURIComponent(
                        contractId
                    )}/${encodeURIComponent(applicationId)}`,
                    data
                )
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
}
